import styled, { keyframes } from 'styled-components';

const loadingPulse = keyframes`
  0%, 100% {
    opacity: 0.45;
    transform: scale(0.9);
  }

  45% {
    opacity: 0.95;
    transform: scale(1.04);
  }
`;

export const ProgressStateContainer = styled.div<{ $isWebview?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${({ $isWebview }) => ($isWebview ? '100vh' : '62vh')};
`;

export const LoadingContent = styled.div`
  align-items: center;
  background-color: #ffffff;
  border-radius: 16px;
  display: flex;
  gap: 12px;
  flex-direction: column;
  padding: 32px 10px;
  width: min(480px, calc(100vw - 32px));
  gap: 16px;
`;

export const LoadingDots = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
  margin-top: 7px;
`;

export const LoadingDot = styled.span<{ $delay: string }>`
  animation: ${loadingPulse} 0.9s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay};
  display: inline-flex;
`;

export const ProgressTitle = styled.div`
  color: ${({ theme }) => theme.color.ui.grey[90]};
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  margin: 0 auto;
  max-width: 260px;
  text-align: center;
  white-space: normal;

  span {
    display: block;
  }
`;
